import { Component, Inject } from "@angular/core";
import { DatePipe } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { EditSubscriptionModel } from "../Subscriptions";
import { MaxSubscribersToCreatePerPark } from "../../../dataTypes/MaxSubscribersToCreatePerPark";
import { ParkForReservedSubscriber } from "../../../dataTypes/ParkForReservedSubscriber";

import * as moment from 'moment';

@Component({
  selector: 'editSubscriber-dialog',
  templateUrl: './editSubscriber.dialog.html',
  styleUrls: ['./editSubscriber.dialog.css'],
})
export class EditSubscriberDialog {

  public _startDate: Date;
  public _endDate: Date;
  //public startTime: string = "00:00";
  //public endTime: string = "00:00";
  public _errorString: string;

  public _selectedPark: number;
  public _selectedDestinedPark: number;


  public _maxSubscribersToCreatePerParkList: MaxSubscribersToCreatePerPark[];

  public _originalSubscriberDestinedPark: number;
  public _originalSubscriberReservedPark: number;

  public _canPopulateReservedCombos: boolean;
  //---------------
  public _isNewSubscriber = true;
  //----------------

  constructor(
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<EditSubscriberDialog>,
    @Inject(MAT_DIALOG_DATA) public _EditSubscriberDialogModel: EditSubscriptionModel) {

    this._canPopulateReservedCombos = false;
    
    this._originalSubscriberDestinedPark = 0;

    if (_EditSubscriberDialogModel.parksForReservedSubscriber.length > 0) {

      let parksForReservedSubscriber: ParkForReservedSubscriber[] = [];

      _EditSubscriberDialogModel.parksForReservedSubscriber.forEach((element, index) => {
        if (parksForReservedSubscriber.findIndex(x => x.id == element.id) === -1) {
          parksForReservedSubscriber.push(element);
        }
      });

      _EditSubscriberDialogModel.parksForReservedSubscriber = parksForReservedSubscriber;
      this._canPopulateReservedCombos = true;

      this._selectedPark = _EditSubscriberDialogModel.parksForReservedSubscriber[0].id;

      if (this._EditSubscriberDialogModel.isAtidim === true) {

        let parksForDestinedSubscriber: ParkForReservedSubscriber[] = [];
        

        _EditSubscriberDialogModel.parksForDestinedSubscriber.forEach((element, index) => {
          if (parksForDestinedSubscriber.findIndex(x => x.id == element.id) === -1) {
            parksForDestinedSubscriber.push(element);
          }
        });

        _EditSubscriberDialogModel.parksForDestinedSubscriber = parksForDestinedSubscriber;

        this._selectedDestinedPark = _EditSubscriberDialogModel.parksForDestinedSubscriber[0].id;
 
      }
    }

    if (_EditSubscriberDialogModel.isEdit === false) { // new
      //-------------
      this._isNewSubscriber = true;
      //----------------
      _EditSubscriberDialogModel.subscription.isReservedPlace = false;

      this._startDate = new Date();
      this._endDate = new Date();
      this._endDate.setMonth(this._startDate.getMonth() + 1); // add month day to today
    }
    else { // edit
      //------------
      this._isNewSubscriber = false;
      //-------------
      this._originalSubscriberDestinedPark = this._EditSubscriberDialogModel.subscription.destinedPark;
      this._originalSubscriberReservedPark = this._EditSubscriberDialogModel.subscription.reservedParkID;

      if (this._EditSubscriberDialogModel.subscription.isReservedPlace && this._EditSubscriberDialogModel.subscription.reservedParkID > 0) {
        this._selectedPark = this._EditSubscriberDialogModel.parksForReservedSubscriber.filter(x => x.id === this._EditSubscriberDialogModel.subscription.reservedParkID)[0].id;
      }

      if (this._EditSubscriberDialogModel.subscription.destinedPark > 0) {
        this._selectedDestinedPark = this._EditSubscriberDialogModel.parksForDestinedSubscriber.filter(x => x.id === this._EditSubscriberDialogModel.subscription.destinedPark)[0].id;
      }
      try {
 
        this._startDate = new Date(this._EditSubscriberDialogModel.subscription.menuimStartDate);
        //this.startTime = this._EditSubscriberDialogModel.subscription.menuimStartDate.substring(11, 16);
        if (this._EditSubscriberDialogModel.subscription.menuimEndDate != null) {
          this._endDate = new Date(this._EditSubscriberDialogModel.subscription.menuimEndDate);
          //this.endTime = this._EditSubscriberDialogModel.subscription.menuimEndDate.substring(11, 16);
        }
        else {
          this._endDate = new Date();
          this._endDate.setMonth(this._startDate.getMonth() + 1); // add month day to today
        }
      } catch (e) {
        console.error(e);
      }

      if (this._EditSubscriberDialogModel.isAtidim === true && this._EditSubscriberDialogModel.subscription.destinedPark) {
        this._selectedDestinedPark = _EditSubscriberDialogModel.parksForDestinedSubscriber.find(x => x.id === this._EditSubscriberDialogModel.subscription.destinedPark).id;

        if (!this._selectedDestinedPark) {

          this._selectedDestinedPark = _EditSubscriberDialogModel.parksForDestinedSubscriber[0].id;

        }
      }


      if (this._EditSubscriberDialogModel.subscription.isReservedPlace === true) {
        this._selectedPark = _EditSubscriberDialogModel.parksForReservedSubscriber.find(x => x.id === this._EditSubscriberDialogModel.subscription.reservedParkID).id;
        if (!this._selectedPark) {
          this._selectedPark = _EditSubscriberDialogModel.parksForReservedSubscriber[0].id;
        }
      }

    }
  }

  onSaveClick(): void {

    //const [hs, ms] = this.startTime.split(":");
    //let hoursStart = Number.parseInt(hs), minutesStart = Number.parseInt(ms);

    //try {
    //  if (this._startDate instanceof Date) {
    //    this._startDate.setHours(hoursStart, minutesStart);
    //    this._startDate.setSeconds(0);
    //  }
    //  else {
    //    console.log('Start date not instanceof Date');
    //    const dmh = moment(this._startDate);
    //    dmh.set('hour', hoursStart).set('minute', minutesStart);
    //    this._startDate = dmh.toDate();
    //  }

    //} catch (e) {
    //  console.log(e);
    //}

    //// ---- End Time Section
    //const [he, me] = this.endTime.split(":");
    //let hoursEnd = Number.parseInt(he), minutesEnd = Number.parseInt(me);
    //try {
    //  if (this._endDate instanceof Date) {
    //    this._endDate.setHours(hoursEnd, minutesEnd);
    //    this._endDate.setSeconds(0);
    //  }
    //  else {
    //    console.log('End date not instanceof Date');
    //    const dmh = moment(this._endDate);
    //    dmh.set('hour', hoursEnd).set('minute', minutesEnd);
    //    this._endDate = dmh.toDate();

    //  }
    //} catch (e) {
    //  console.log(e);
    //}
    console.log('End date ' + this._endDate.toString());

    this._EditSubscriberDialogModel.subscription.menuimStartDate = this.datePipe.transform(this._startDate, 'yyyy-MM-dd HH:mm');
    this._EditSubscriberDialogModel.subscription.menuimEndDate = this.datePipe.transform(this._endDate, 'yyyy-MM-dd HH:mm');

    if (this._EditSubscriberDialogModel.subscription.isReservedPlace === true) {
      this._EditSubscriberDialogModel.subscription.reservedParkID = this._selectedPark;

    }
    else {
      this._EditSubscriberDialogModel.subscription.destinedPark = this._selectedDestinedPark;
    }

    if (this.InputFieldsAreValid() === true) {
      this.dialogRef.close(this._EditSubscriberDialogModel.subscription);
    }
    else {
      // show alert
      console.log('Subscriber Validation failed');
   
    }

    //--------
    this._isNewSubscriber = false;
   //--------

  }
  onNoClick(): void {
    //-------
    this._isNewSubscriber = false;
    //----------
    this.dialogRef.close();
  }

  InputFieldsAreValid(): boolean {


    this._errorString = '';

    const identityRe = /^-?\d+\.?\d*$/;
    if (this._EditSubscriberDialogModel.subscription.phone) {
      if (!identityRe.test(String(this._EditSubscriberDialogModel.subscription.phone))) {
        this._errorString = 'phoneNumberWrongFormat';
        return;
      }
      if (this._EditSubscriberDialogModel.subscription.phone.length !== 10) {
        this._errorString = 'phoneNumberWrongFormat';
        return;
      }
    }

    

    if (!this._EditSubscriberDialogModel.subscription.name) {
      this._errorString = 'FirstNameCantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.lastName) {
      this._errorString = 'LastNamecantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimCarNo) {
      this._errorString = 'CarNumbercantbeempty', 'error';
      return;
    }

    const carRe = /^\d+$/;
    if (!carRe.test(this._EditSubscriberDialogModel.subscription.menuimCarNo)) {
      this._errorString = 'InvalidformatofCarNumber', 'error';
      return;
    }

    if (this._EditSubscriberDialogModel.subscription.menuimCarNo2) {
      if (!carRe.test(this._EditSubscriberDialogModel.subscription.menuimCarNo2)) {
        this._errorString = 'InvalidformatofCarNumber', 'error';
        return;
      }
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimStartDate) {
      this._errorString = 'Datecantbeempty', 'error';
      return;
    }

    if (!this._EditSubscriberDialogModel.subscription.menuimEndDate) {

      this._errorString = 'EndDatecantbeempty', 'error';
      return;
    }

    if (this._endDate < new Date() || this._startDate < new Date(2000, 1, 1)) {
     
      this._errorString = 'DatesInvalid', 'error';
      return;
    }



    if (this._EditSubscriberDialogModel.isAtidim && this._EditSubscriberDialogModel.subscription.destinedPark <= 0 && this._EditSubscriberDialogModel.subscription.isReservedPlace === false)
    {
      this._errorString = 'DestinedParkCannotBeEmpty';
      return;
    }



    if (this._EditSubscriberDialogModel.isAtidim == true && this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList)
    {
      let subscribersWithDestinedPark_subscribersAmount: number;
      subscribersWithDestinedPark_subscribersAmount = 0;

      // destined
      if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.length > 0 && this._EditSubscriberDialogModel.subscription.destinedPark > 0
        && this._EditSubscriberDialogModel.subscription.isReservedPlace == false) {

        if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList) {

          var t = this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.destinedPark);

          if (this._EditSubscriberDialogModel.subscribersWithDestinedPark) {
            var subscribersWithDestinedPark =
              this._EditSubscriberDialogModel.subscribersWithDestinedPark.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.destinedPark);

            if (subscribersWithDestinedPark) subscribersWithDestinedPark_subscribersAmount = subscribersWithDestinedPark.subscribersAmount;
          }
          else subscribersWithDestinedPark_subscribersAmount = 0;



          if (t) {
            // new
            if (this._EditSubscriberDialogModel.isEdit === false && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

              this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
              return;

            }
            else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.isReservedPlace === false &&
              this._EditSubscriberDialogModel.subscription.reservedParkID === this._EditSubscriberDialogModel.subscription.destinedPark) {
              return true;
            }
            else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.destinedPark !== this._originalSubscriberDestinedPark
              && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

              this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
              return;
            }
            else {
              return true;
            }
          }
          else {
            return true;
          }
        }
      }

      // reserved
      if (this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.length > 0 && this._EditSubscriberDialogModel.subscription.reservedParkID > 0
        && this._EditSubscriberDialogModel.subscription.isReservedPlace == true) {

        var t = this._EditSubscriberDialogModel.maxSubscribersToCreatePerParkList.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.reservedParkID);

        var subscribersWithDestinedPark =
          this._EditSubscriberDialogModel.subscribersWithDestinedPark.find(x => x.parkNumber == this._EditSubscriberDialogModel.subscription.reservedParkID);

        if (subscribersWithDestinedPark) subscribersWithDestinedPark_subscribersAmount = subscribersWithDestinedPark.subscribersAmount;

        if (t) {
          // new
          if (this._EditSubscriberDialogModel.isEdit === false && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

            this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
            return;

          }
          else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.isReservedPlace === true &&
            this._EditSubscriberDialogModel.subscription.reservedParkID === this._originalSubscriberDestinedPark) {
            return true;
          }
          else if (this._EditSubscriberDialogModel.isEdit === true && this._EditSubscriberDialogModel.subscription.reservedParkID !== this._originalSubscriberReservedPark
            && t.maximumSubscribersWithDestinedParkToCreate <= subscribersWithDestinedPark_subscribersAmount) {

            this._errorString = 'UnableToCreateMoreSubscribersFprDestinedPark';
            return;
          }
          else {
            return true;
          }
        }
        else {
          return true;
        }
      }

    }

    else {
      return true;
    }
  }
  endDatemodelchange(value) {
    console.debug('Subscriber endDatemodelchange ' + value);          //Changed Value
    console.debug(this._endDate);  //undefined
  }
}
